module.exports = __webpack_public_path__ + "img/3f_l_sapporo.3be9d88f.png";